(() => {
  function parseCents(value) {
    const cents = Number(String(value || '').replace(/[^\d.-]/g, ''));
    return Number.isFinite(cents) ? cents : 0;
  }

  function parseQuantity(value, fallback = 1) {
    const quantity = Number(value);
    return Number.isFinite(quantity) ? Math.min(quantity, 100) : fallback;
  }

  function getQuoteQuantity(form) {
    const formQuantityInput = form.querySelector('input[name="quantity"]');
    if (formQuantityInput) return parseQuantity(formQuantityInput.value);

    const productInfoQuantityInput =
      form.closest('product-info')?.querySelector('.quantity__input[name="quantity"]') ||
      document.querySelector('product-info .quantity__input[name="quantity"]');

    return parseQuantity(productInfoQuantityInput?.value, 1);
  }

  function getSelectedCustomOptions(form) {
    const productInfo = form.closest('product-info') || document;
    const pickers = productInfo.querySelectorAll('[data-custom-variant-picker]');
    if (!pickers.length) return [];

    return Array.from(pickers).flatMap((picker) => Array.from(
      picker.querySelectorAll('.custom-variant-picker__options input[type="radio"], .custom-variant-picker__options input[type="checkbox"]'),
    ))
      .filter((option) => option.checked && !String(option.id || '').includes('none'));
  }

  function hasCustomVariantPicker(form) {
    const productInfo = form.closest('product-info') || document;
    return Boolean(productInfo.querySelector('[data-custom-variant-picker]'));
  }

  function getQuoteTitle(form) {
    const productTitle = form.dataset.productTitle || '';
    const variantTitle = String(form.dataset.productVariantTitle || '').trim();
    return variantTitle && variantTitle.toLowerCase() !== 'default title'
      ? [productTitle, variantTitle].filter(Boolean).join(' — ')
      : productTitle;
  }

  function buildQuoteItem(form) {
    const variantInput = form.querySelector('input[name="id"]');
    const variantId = variantInput?.value || form.dataset.productVariantId || '';
    const priceCents = parseCents(form.dataset.productBasePrice);
    const quantity = getQuoteQuantity(form);
    const selectedCustomOptions = getSelectedCustomOptions(form);
    const customOptionItems = selectedCustomOptions.map((option) => {
      const optionPriceCents = parseCents(option.dataset.price);
      return {
        title: `${option.name}: ${option.value}`,
        image: option.dataset.optionImage
          ? {
            url: option.dataset.optionImage,
            alt: option.dataset.optionImageAlt || option.value,
          }
          : null,
        priceCents: optionPriceCents,
        included: optionPriceCents === 0,
      };
    });
    const selectedCustomOptionsTotal = customOptionItems.reduce((total, option) => total + option.priceCents, 0);
    const finalPriceCents = priceCents + selectedCustomOptionsTotal;
    const basePriceImage = form.dataset.productImage
      ? {
        url: form.dataset.productImage,
        alt: form.dataset.productImageAlt || form.dataset.productTitle || 'Base Price',
      }
      : null;

    return {
      id: variantId,
      variant_id: variantId,
      product_id: form.dataset.productId || '',
      product_title: form.dataset.productTitle || '',
      title: getQuoteTitle(form),
      handle: form.dataset.productHandle || '',
      url: form.dataset.productUrl || '',
      image: form.dataset.productImage || null,
      sku: variantInput?.dataset.variantSku || '',
      quantity,
      price: finalPriceCents,
      final_price: finalPriceCents,
      line_price: finalPriceCents * quantity,
      final_line_price: finalPriceCents * quantity,
      properties: {
        ...selectedCustomOptions.reduce((properties, option) => {
          properties[`option_product-${option.name}`] = {
            id: option.dataset.variantId || option.id,
            value: option.value,
            sku: option.dataset.sku,
          };
          return properties;
        }, {}),
        _quote_source: hasCustomVariantPicker(form) ? 'custom_variant_picker' : 'product_quote_form',
        _price: finalPriceCents / 100,
        _quote_options: {
          currency: form.dataset.currency || window.Shopify?.currency?.active || 'AUD',
          items: customOptionItems,
          basePrice: {
            title: 'Base Price',
            image: basePriceImage,
            priceCents,
            included: false,
          },
        },
      },
    };
  }

  function showFormError(form, message) {
    const errors = form.querySelector('[data-add-to-quote-error]') || document.getElementById('ProductSubmitError');
    if (errors) errors.textContent = message || 'Error adding to quote';
  }

  function redirectTo(url) {
    if (typeof navigator !== 'undefined' && /jsdom/i.test(navigator.userAgent || '')) {
      return;
    }

    window.location.assign(new URL(url, window.location.origin).toString());
  }

  if (document.documentElement.dataset.productQuoteFormSubmitBound === 'true') return;

  window.Express = window.Express || {};
  window.Express.productQuoteFormSubmitBound = true;
  document.documentElement.dataset.productQuoteFormSubmitBound = 'true';

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-quote-form]');
    if (!form || form.dataset.productBuilderId) return;

    event.preventDefault();

    const quoteDraft = window.Express?.quoteDraft;
    if (!quoteDraft || typeof quoteDraft.addItem !== 'function') {
      showFormError(form, 'Quote draft is unavailable. Please refresh and try again.');
      return;
    }

    try {
      quoteDraft.addItem(buildQuoteItem(form));
      redirectTo(form.dataset.quotePageUrl || form.getAttribute('action') || '/pages/request-a-quote');
    } catch (error) {
      showFormError(form, error instanceof Error ? error.message : 'Error adding to quote');
    }
  });
})();
